<template>
  <div>
    <div class="text-nowrap">
      <b-dropdown
        size="sm"
        :text="data.status"
        :variant="badgeVariant(data.status)"
        class="text-light"
      >
        <b-dropdown-item
          v-if="showOption('pending')"
          style="z-index: 999"
          @click="showChangeStatusModal('pending', data.id)"
        >
          Pending
        </b-dropdown-item>
        <b-dropdown-item
          v-if="showOption('approved')"
          style="z-index: 999"
          @click="showChangeStatusModal('approved', data.id)"
        >
          Approved
        </b-dropdown-item>
        <b-dropdown-item
          v-if="showOption('printed')"
          style="z-index: 999"
          @click="showChangeStatusModal('printed', data.id)"
        >
          Printed
        </b-dropdown-item>
        <b-dropdown-item
          v-if="data.status !== 'rejected' && $store.state.app.permissions.includes('show-rejected')"
          style="z-index: 999"
          @click="showChangeStatusModal('rejected', data.id)"
        >
          Rejected
        </b-dropdown-item>
      </b-dropdown>

      <ChangeInvoiceStatus
        :key="InvoiceId"
        :name="name"
        :endpoint="endpoint"
        :inovice-id="InvoiceId"
        :invoicestatus="invoiceLatestStatus"
        @onChange="$emit('onEmit')"
      />
    </div>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import ChangeInvoiceStatus from '@/components/modals/ChangeInvoiceStatus.vue'

export default {
  components: {
    BDropdown,
    BDropdownItem,
    ChangeInvoiceStatus,
  },
  props: ['data', 'endpoint', 'name'],
  data() {
    return {
      invoiceLatestStatus: '',
      InvoiceId: '', // To track the currently selected invoice ID
    }
  },
  methods: {
    showChangeStatusModal(status, id) {
      console.log(id)
      this.invoiceLatestStatus = status
      this.InvoiceId = id // Update the Invoice ID
      this.$nextTick(() => {
        // Ensure the modal is shown after the DOM is updated
        this.$bvModal.show(`modal-confirm-edit-${id}`)
      })
    },

    badgeVariant(status) {
      switch (status) {
        case 'pending':
          return 'warning'
        case 'rejected':
          return 'danger'
        case 'printed':
          return 'info'
        default:
          return 'success'
      }
    },

    showOption(option) {
      const statusSequence = ['pending', 'approved', 'printed']
      const currentIndex = statusSequence.indexOf(this.data.status)
      const optionIndex = statusSequence.indexOf(option)

      if (
        this.data.status === 'printed'
        || this.data.status === 'rejected'
        || this.data.status === 'accountant_approved'
        || this.data.status === 'paid'
        || this.data.status === 'distributed'
      ) {
        return false // Cannot change status once printed or rejected
      }

      return option === 'rejected' || optionIndex === currentIndex + 1
    },
  },
}
</script>
